import { buildProperty, buildCollection } from "@firecms/core";
import enumLocales from "./locales.enum";
import uniqid from "uniqid";

interface ITeamMember {
  name: string;
  order: number;
  active: boolean;
  image: string;
  linkedin: string;
}

const TeamLocaleSchema = buildCollection({
  id: "team_locales",
  name: "Locale",
  path: "locales",
  customId: enumLocales,
  properties: {
    role: buildProperty({
      name: "Role",
      dataType: "string",
      columnWidth: 400,
      validation: { 
        required: false,
        max: 100
      },
      description: "Short role/position title (max 100 characters)",
    }),
    bio: buildProperty({
      name: "Bio",
      dataType: "string",
      columnWidth: 400,
      validation: { required: false },
      markdown: true,
    }),
    description: buildProperty({
      name: "Description",
      dataType: "string",
      columnWidth: 400,
      validation: { required: false },
      markdown: true,
    }),
  },
});

const TeamSchema = buildCollection<ITeamMember>({
  id: "team",
  name: "Team Members",
  path: "team",
  subcollections: [TeamLocaleSchema],
  properties: {
    name: buildProperty({
      name: "Name",
      dataType: "string",
      validation: { required: true },
      columnWidth: 300,
    }),
    order: buildProperty({
      name: "Order",
      dataType: "number",
      defaultValue: 0,
      description: "Display order for team members",
    }),
    active: buildProperty({
      name: "Active",
      dataType: "boolean",
      defaultValue: true,
    }),
    image: buildProperty({
      name: "Profile Image",
      dataType: "string",
      storage: {
        fileName: () => uniqid(),
        acceptedFiles: ["image/*"],
        storagePath: "images/team",
        metadata: {
          cacheControl: "max-age=1000000",
        },
      },
    }),
    linkedin: buildProperty({
      name: "LinkedIn",
      dataType: "string",
      validation: { required: false },
      description: "LinkedIn profile URL",
    }),
  },
});

export default TeamSchema;

